import { render, staticRenderFns } from "./wxdetail.vue?vue&type=template&id=37fa1856&scoped=true&"
import script from "./wxdetail.vue?vue&type=script&lang=js&"
export * from "./wxdetail.vue?vue&type=script&lang=js&"
import style0 from "./wxdetail.vue?vue&type=style&index=0&id=37fa1856&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fa1856",
  null
  
)

export default component.exports